export default "__VITE_ASSET__fOMchow7__"